export default __webpack_public_path__ + "static/media/UI.5dfa66d9.png";